import React from 'react'
import { WeekHeader as GeneralHeader } from '../../../Schedule/components/weekBox'
import type { EventGQL } from '../../../../Api'
type HeaderParams = {
  week: string
  events: EventGQL[]
}

export const WeekHeader: React.FC<React.PropsWithChildren<HeaderParams>> = ({ week, events }) => {
  if (events.length === 0) {
    return <div />
  }
//Reuse Schedule Header
  return (
    <GeneralHeader week={week} events={events} />
  )
}
